export default __webpack_public_path__ + "static/media/carousel4_icon.1b88ad54.png";